import { render, staticRenderFns } from "./KSRService.vue?vue&type=template&id=325635b9&"
import script from "./KSRService.vue?vue&type=script&lang=js&"
export * from "./KSRService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports